import styled from 'styled-components'
import { WidgetImage } from '../../widget.styles'

export const Image = styled(WidgetImage)``
